import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'

const Webinars = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="bg-white">
          <div className="relative bg-gray-900">
            <div className="absolute inset-0">
              <img
                className="w-full h-full object-cover opacity-30"
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
                alt="Webinars"
              />
            </div>
            <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
              <div className="text-center">
                <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                  <span className="block">Marketing Masterclass Webinars</span>
                </h1>
                <p className="mt-6 max-w-3xl mx-auto text-xl text-gray-100">
                  Live and recorded sessions to help you master digital marketing strategies.
                </p>
              </div>
            </div>
          </div>
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            {/* Upcoming Webinars */}
            <div className="mb-20">
              <h2 className="text-2xl font-bold text-gray-900 mb-8 pb-2 border-b border-gray-200">
                Upcoming Live Webinars
              </h2>
              <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                {/* Webinar 1 */}
                <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                  <div className="flex-shrink-0 relative">
                    <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="AI in Marketing" />
                    <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">
                      LIVE JULY 25
                    </div>
                  </div>
                  <div className="flex-1 bg-white p-6 flex flex-col">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-primary">
                        AI & Automation
                      </p>
                      <h3 className="text-xl font-semibold text-gray-900 mt-2">
                        Revolutionizing Marketing with AI
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        Discover how to leverage AI tools to automate and optimize your marketing campaigns.
                      </p>
                    </div>
                    <div className="mt-6">
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="flex-shrink-0 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                        <p>July 25, 2023 • 2:00 PM EST</p>
                      </div>
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="flex-shrink-0 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                        </svg>
                        <p>60 minutes + Q&A</p>
                      </div>
                      <Link
                        to="/webinars/ai-marketing"
                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                      >
                        Reserve Your Spot
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Webinar 2 */}
                <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                  <div className="flex-shrink-0 relative">
                    <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="SEO Strategy" />
                    <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">
                      LIVE AUGUST 8
                    </div>
                  </div>
                  <div className="flex-1 bg-white p-6 flex flex-col">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-primary">
                        SEO Strategy
                      </p>
                      <h3 className="text-xl font-semibold text-gray-900 mt-2">
                        2023 SEO Blueprint
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        The complete framework for dominating search rankings in the new algorithm landscape.
                      </p>
                    </div>
                    <div className="mt-6">
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="flex-shrink-0 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                        <p>August 8, 2023 • 1:00 PM EST</p>
                      </div>
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="flex-shrink-0 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                        </svg>
                        <p>75 minutes + Q&A</p>
                      </div>
                      <Link
                        to="/webinars/seo-blueprint"
                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                      >
                        Reserve Your Spot
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Webinar 3 */}
                <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                  <div className="flex-shrink-0 relative">
                    <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Conversion Optimization" />
                    <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">
                      LIVE AUGUST 22
                    </div>
                  </div>
                  <div className="flex-1 bg-white p-6 flex flex-col">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-primary">
                        Conversion Optimization
                      </p>
                      <h3 className="text-xl font-semibold text-gray-900 mt-2">
                        High-Converting Landing Pages
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        Science-backed techniques to transform your landing pages into conversion machines.
                      </p>
                    </div>
                    <div className="mt-6">
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="flex-shrink-0 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                        <p>August 22, 2023 • 3:00 PM EST</p>
                      </div>
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="flex-shrink-0 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                        </svg>
                        <p>90 minutes + Q&A</p>
                      </div>
                      <Link
                        to="/webinars/conversion-optimization"
                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                      >
                        Reserve Your Spot
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Recorded Webinars */}
            <div className="mb-20">
              <h2 className="text-2xl font-bold text-gray-900 mb-8 pb-2 border-b border-gray-200">
                Recorded Webinars
              </h2>
              <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                {/* Webinar 4 */}
                <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                  <div className="flex-shrink-0 relative">
                    <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Social Media" />
                    <div className="absolute top-2 right-2 bg-gray-600 text-white text-xs font-bold px-2 py-1 rounded">
                      RECORDED
                    </div>
                  </div>
                  <div className="flex-1 bg-white p-6 flex flex-col">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-primary">
                        Social Media
                      </p>
                      <h3 className="text-xl font-semibold text-gray-900 mt-2">
                        Algorithm-Proof Social Strategy
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        How to build an engaged audience that survives platform algorithm changes.
                      </p>
                    </div>
                    <div className="mt-6">
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="flex-shrink-0 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        <p>Recorded June 15, 2023</p>
                      </div>
                      <Link
                        to="/webinars/social-strategy"
                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                      >
                        Watch Now
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Webinar 5 */}
                <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                  <div className="flex-shrink-0 relative">
                    <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Email Marketing" />
                    <div className="absolute top-2 right-2 bg-gray-600 text-white text-xs font-bold px-2 py-1 rounded">
                      RECORDED
                    </div>
                  </div>
                  <div className="flex-1 bg-white p-6 flex flex-col">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-primary">
                        Email Marketing
                      </p>
                      <h3 className="text-xl font-semibold text-gray-900 mt-2">
                        Automated Email Sequences That Convert
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        Build email workflows that nurture leads and drive revenue on autopilot.
                      </p>
                    </div>
                    <div className="mt-6">
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="flex-shrink-0 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        <p>Recorded May 10, 2023</p>
                      </div>
                      <Link
                        to="/webinars/email-sequences"
                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                      >
                        Watch Now
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Webinar 6 */}
                <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                  <div className="flex-shrink-0 relative">
                    <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Paid Ads" />
                    <div className="absolute top-2 right-2 bg-gray-600 text-white text-xs font-bold px-2 py-1 rounded">
                      RECORDED
                    </div>
                  </div>
                  <div className="flex-1 bg-white p-6 flex flex-col">
                    <div className="flex-1">
                      <p className="text-sm font-medium text-primary">
                        Paid Advertising
                      </p>
                      <h3 className="text-xl font-semibold text-gray-900 mt-2">
                        Google Ads Masterclass
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        Advanced strategies to maximize ROI from your Google Ads campaigns.
                      </p>
                    </div>
                    <div className="mt-6">
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <svg className="flex-shrink-0 mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        <p>Recorded April 5, 2023</p>
                      </div>
                      <Link
                        to="/webinars/google-ads"
                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                      >
                        Watch Now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-primary-50 rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Want Custom Training for Your Team?
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                We offer private webinars and workshops tailored to your business needs.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
              >
                Request Private Training
                <svg className="ml-3 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Webinars